import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  typography: {
    allVariants: {
      color: '#494949',
    },
    fontFamily: `"Montserrat", sans-serif`,
  },
});

export default theme;
